import { mdiArrowULeftTop } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { formatTuple, ICurrentClaimProgress } from './claim-progress-derivation';
import { TONE_COLORS, VISUAL_STATE_VIEW } from './claim-progress-visuals';
import { ClaimStatePills } from './claim-state-pill';
import * as S from './claim-live-status-card.styles';

interface IClaimLiveStatusCardProps {
    current: ICurrentClaimProgress;
}

const EMPTY_HEADLINE = 'No workflow activity recorded yet';
const EMPTY_DETAIL = 'This claim has no workflow history. Progress will appear after the first workflow event.';

const MetaCell: React.FC<{ label: string; value: string; code?: boolean }> = ({ label, value, code }) => (
    <S.MetaCellRoot>
        <S.MetaLabel>{label}</S.MetaLabel>
        <S.MetaValue $code={code}>{value}</S.MetaValue>
    </S.MetaCellRoot>
);

export const ClaimLiveStatusCard: React.FC<IClaimLiveStatusCardProps> = ({ current }) => {
    const { event } = current;

    if (!event) {
        return (
            <S.Card>
                <S.AccentBar $color={TONE_COLORS.grey.border} />
                <S.Primary>
                    <S.Eyebrow>{current.eyebrow}</S.Eyebrow>
                    <S.Headline>{EMPTY_HEADLINE}</S.Headline>
                    <S.Detail>{EMPTY_DETAIL}</S.Detail>
                </S.Primary>
            </S.Card>
        );
    }

    const tone = VISUAL_STATE_VIEW[event.visualState].tone;

    return (
        <S.Card>
            <S.AccentBar $color={TONE_COLORS[tone].foreground} />
            <S.Layout>
                <S.Primary>
                    <S.Eyebrow>{current.eyebrow}</S.Eyebrow>
                    <S.PillRow>
                        <ClaimStatePills event={event} large />
                    </S.PillRow>
                    <S.Headline>{event.label}</S.Headline>
                    {event.detail && <S.Detail>{event.detail}</S.Detail>}
                    {event.reworkReason && (
                        <S.ReworkReason>
                            <Icon path={mdiArrowULeftTop} size={0.65} />
                            Rework: {event.reworkReason}
                        </S.ReworkReason>
                    )}
                </S.Primary>
                <S.Meta>
                    <MetaCell
                        label="Source"
                        value={formatTuple(event.status, event.step, event.action, event.attempt)}
                        code
                    />
                </S.Meta>
            </S.Layout>
        </S.Card>
    );
};
